import { AppointmentType } from 'kb-shared/types';
import { MEMBER_SERVICES_PHONE_NUMBER } from 'screens/Book/memberServicesPhone';

export const ONLINE_BOOKING_UNAVAILABLE_PHONE_NUMBER = MEMBER_SERVICES_PHONE_NUMBER;
export const ONLINE_BOOKING_UNAVAILABLE_PHONE_HREF = `tel://${ONLINE_BOOKING_UNAVAILABLE_PHONE_NUMBER}`;
export const ONLINE_BOOKING_UNAVAILABLE_MESSAGE =
  'Self-scheduling is currently unavailable for this market. Please call us to schedule at';

export const isOnlineBookingUnavailableForAppointmentType = ({
  appointmentType
}: {
  appointmentType?: AppointmentType | null;
}) => Boolean(appointmentType?.disableOnlineBooking);
